import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Navbar } from './Navbar';
import { Footer } from './Footer';
import { ScrollToTop } from '../common/ScrollToTop';
import { ScrollProgressBar } from '../common/ScrollProgressBar';
import { PageTransition } from '../common/PageTransition';
import { SkipToContent } from '../common/SkipToContent';
import { WhatsAppButton } from '../common/WhatsAppButton';

interface LayoutProps {
  children: React.ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');

  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  // Update page title for screen readers
  useEffect(() => {
    if (isAdminRoute) {
      return;
    }
    const mainHeading = document.querySelector('h1');
    if (mainHeading) {
      document.title = `${mainHeading.textContent} | FirstLogic Technologies`;
    }
  }, [location.pathname, isAdminRoute]);

  if (isAdminRoute) {
    return <>{children}</>;
  }

  return (
    <div className="min-h-screen flex flex-col bg-background-light dark:bg-background-dark">
      <SkipToContent />
      <ScrollProgressBar />
      <Navbar />
      <main id="main-content" className="flex-grow" tabIndex={-1}>
        <PageTransition>
          {children}
        </PageTransition>
      </main>
      <Footer />
      <ScrollToTop />
      <WhatsAppButton />
    </div>
  );
};